var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('nav',{staticClass:"mainnavigation"},[_c('router-link',{attrs:{"to":"/"}}),_vm._v(" "),_c('router-link',{attrs:{"to":"/aufnahme"}}),_vm._v(" "),_c('router-link',{attrs:{"to":"/app"}}),_vm._v(" "),_c('router-link',{attrs:{"to":"/spenden"}})],1),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42228439","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 78
// module chunks = 1